import React from 'react'
import { GAME_TOKEN_KUDA } from "assets/images"

const MemoizedImageKUDA = () => {
  return (
    <img src={GAME_TOKEN_KUDA} alt='' className='game-token-merah' loading="lazy" />
  )
}
export default React.memo(MemoizedImageKUDA) 
